import styled, { css } from 'styled-components';
import { Link, P, A } from 'components/Typography';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Heading = styled(P)`
  color: ${th('colors.white')};
  font-weight: bold;
`;

const linkStyles = css`
  padding-top: ${th('space.2')}px;
  color: ${th('colors.silverChaliceGray')};
  display: block;
  font-weight: bold;
  text-decoration: none;

  :hover {
    color: ${th('colors.white')};
  }
`;

export const FooterLink = styled(Link)`
  ${linkStyles};
`;

export const ExternalFooterLink = styled(A)`
  ${linkStyles};
`;

export const FooterContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${th('space.6')}px;
  font-size: 14px;
  line-height: 1.5;
  background-color: ${th('colors.black')};

  > :not(:first-child) {
    padding-top: ${th('space.8')}px;
  }

  @media ${sizes.tabletPortrait} {
    padding: ${th('space.10')}px;
  }

  @media ${sizes.desktop} {
    font-size: 12px;
    line-height: initial;
    flex-direction: row;

    > :not(:first-child) {
      padding-top: ${th('space.0')}px;
    }

    > :not(:last-child) {
      display: flex;
    }

    > * {
      flex: 2;
    }
    > :nth-child(2) {
      flex: 3;
    }
  }

  @media ${sizes.desktop} {
    > :nth-child(2) {
      flex: 3;
    }
  }
`;

export const CopyrightText = styled(P)`
  box-sizing: border-box;
  padding-top: ${th('space.5')}px;
  color: ${th('colors.silverChaliceGray')};
  font-size: 12px;
`;

export const FeatherLogo = styled.img`
  height: 100px;
  padding-right: 20px;
  margin-left: -10px;

  @media ${sizes.tabletLandscape} {
    margin-left: 0;
  }
`;

export const LocationsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Locations = styled.div`
  > * {
    margin: 0;
    color: ${th('colors.white')};
    font-size: 14px;

    @media ${sizes.tabletLandscape} {
      font-size: 12px;
    }

    &:not(:first-child) {
      padding-top: ${th('space.1')}px;
    }
  }
`;

export const InternalLinks = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    box-sizing: border-box;
    padding-right: ${th('space.9')}px;
    padding-top: ${th('space.5')}px;
  }

  @media ${sizes.tabletPortrait} {
    flex-direction: row;

    > * {
      padding-top: 0;
      min-width: 130px;
    }
  }

  @media ${sizes.tabletLandscape} {
    > * {
      min-width: initial;
    }
  }

  @media ${sizes.desktop} {
    > * {
      min-width: 150px;
    }
  }

  @media ${sizes.largeDesktop} {
    justify-content: center;
    padding-right: 100px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: flex-start;

  @media ${sizes.desktop} {
    justify-content: center;
  }
`;

export const Icons = styled.div`
  padding: ${th('space.2')}px 0;
  color: ${th('colors.silverChaliceGray')};

  > a {
    color: ${th('colors.silverChaliceGray')};
  }

  > :not(:last-child) {
    padding-right: ${th('space.4')}px;
  }
`;
